import { dataLineChartAlt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLineChartAlt = /*#__PURE__*/createIcon(dataLineChartAlt)
export default IconLineChartAlt
